package com.shadowings.gero.data.lessons.chapter14

import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.data.repository.SentenceOptions
import kotlin.random.Random
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.model.Verb
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_il_segreto_della_piramide_1
import gero.composeapp.generated.resources.exp_content_il_segreto_della_piramide_10
import gero.composeapp.generated.resources.exp_content_il_segreto_della_piramide_11
import gero.composeapp.generated.resources.exp_content_il_segreto_della_piramide_12
import gero.composeapp.generated.resources.exp_content_il_segreto_della_piramide_13
import gero.composeapp.generated.resources.exp_content_il_segreto_della_piramide_14
import gero.composeapp.generated.resources.exp_content_il_segreto_della_piramide_2
import gero.composeapp.generated.resources.exp_content_il_segreto_della_piramide_3
import gero.composeapp.generated.resources.exp_content_il_segreto_della_piramide_4
import gero.composeapp.generated.resources.exp_content_il_segreto_della_piramide_5
import gero.composeapp.generated.resources.exp_content_il_segreto_della_piramide_6
import gero.composeapp.generated.resources.exp_content_il_segreto_della_piramide_7
import gero.composeapp.generated.resources.exp_content_il_segreto_della_piramide_8
import gero.composeapp.generated.resources.exp_content_il_segreto_della_piramide_9
import gero.composeapp.generated.resources.exp_title_il_segreto_della_piramide
import gero.composeapp.generated.resources.tale_1_12

fun getIlSegretoDellaPiramideContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_il_segreto_della_piramide,
            content = Res.string.exp_content_il_segreto_della_piramide_1,
            face = Faces.Happy,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_segreto_della_piramide,
            content = Res.string.exp_content_il_segreto_della_piramide_2,
            face = Faces.Happy,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_segreto_della_piramide,
            content = Res.string.exp_content_il_segreto_della_piramide_3,
            face = Faces.Surprised,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_segreto_della_piramide,
            content = Res.string.exp_content_il_segreto_della_piramide_4,
            face = Faces.Idle,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_segreto_della_piramide,
            content = Res.string.exp_content_il_segreto_della_piramide_5,
            face = Faces.Surprised,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_segreto_della_piramide,
            content = Res.string.exp_content_il_segreto_della_piramide_6,
            face = Faces.Idle,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_segreto_della_piramide,
            content = Res.string.exp_content_il_segreto_della_piramide_7,
            face = Faces.Surprised,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_segreto_della_piramide,
            content = Res.string.exp_content_il_segreto_della_piramide_8,
            face = Faces.Happy,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_segreto_della_piramide,
            content = Res.string.exp_content_il_segreto_della_piramide_9,
            face = Faces.Happy,
            character = Characters.Masko,
            image = Res.drawable.tale_1_12,
            applyFilter = false,
            imageSize = 0.5f,
            fullscreenable = true,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_segreto_della_piramide,
            content = Res.string.exp_content_il_segreto_della_piramide_10,
            face = Faces.Surprised,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_segreto_della_piramide,
            content = Res.string.exp_content_il_segreto_della_piramide_11,
            face = Faces.Idle,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_segreto_della_piramide,
            content = Res.string.exp_content_il_segreto_della_piramide_12,
            face = Faces.Doubt,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_segreto_della_piramide,
            content = Res.string.exp_content_il_segreto_della_piramide_13,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_segreto_della_piramide,
            content = Res.string.exp_content_il_segreto_della_piramide_14,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
    )
}

fun getIlSegretoDellaPiramideQuizContent(
    hiero: List<Hiero> = emptyList(),
    words: List<Word> = emptyList(),
    verbs: List<Verb> = emptyList(),
    languageCode: String = "",
    verbSentences: List<SentenceOptions> = emptyList(),
    random: Random = Random
): List<IQuizContent> = getRieccoloDiNuovoQuizContent(
    hiero = hiero,
    words = words,
    verbs = verbs,
    languageCode = languageCode,
    verbSentences = verbSentences,
    random = random
)
